module.exports = __webpack_public_path__ + "static/img/goodness8.a1ba88bf.png";